import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { environment } from '../../../../environments/environment';

export enum ButtonType {
  white = 'white',
  black = 'black'
}

@Component({
    selector: 'glo-button',
    imports: [CommonModule],
    templateUrl: './glo-button.component.html',
    styleUrl: './glo-button.component.scss'
})
export class GloButtonComponent {
  @Input() icon: string = ''; 
  @Input() value: string = '';
  @Input() type: string = ButtonType.white;
  @Input() size = 16;
  @Input() fullWidth = false;
  @Input() classes = '';
  @Input() hideTextOnMobile: boolean = false;
  @Input() disabled: boolean = false;

  assetUrl = environment.assetBaseUrl


  types = ButtonType;
}
